import { TOGGLE_CONFIRMATION_LEAVING_SPOT } from "./displayConfirmationLeavingSpotReducer"

export const toggleConfirmationLeavingSpot = (value) => ({
    type: TOGGLE_CONFIRMATION_LEAVING_SPOT,
    payload: value
})